import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './translations/en.json';
import esTranslations from './translations/es.json';
import frTranslations from './translations/fr.json';
import deTranslations from './translations/de.json';
import ptTranslations from './translations/pt.json';
import ptTools from './translations/tools.pt.json';
import enTools from './translations/tools.en.json';
import esTools from './translations/tools.es.json';
import frTools from './translations/tools.fr.json';
import deTools from './translations/tools.de.json';

function detectInitialLanguage() {
  try {
    const path = typeof window !== 'undefined' ? window.location.pathname : '';
    const seg = path.split('/').filter(Boolean)[0];
    const supported = ['en', 'es', 'fr', 'de', 'pt'];
    if (supported.includes(seg)) return seg;
    const saved = typeof window !== 'undefined' ? localStorage.getItem('selectedLanguage') : null;
    if (saved && supported.includes(saved)) return saved;
    const browser = typeof navigator !== 'undefined' ? navigator.language?.split('-')[0] : 'en';
    if (supported.includes(browser)) return browser;
  } catch {}
  return 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations, tools: enTools },
      es: { translation: esTranslations, tools: esTools },
      fr: { translation: frTranslations, tools: frTools },
      de: { translation: deTranslations, tools: deTools },
      pt: { translation: ptTranslations, tools: ptTools }
    },
    lng: detectInitialLanguage(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n;